const PRESCRIPTION_SORT_ORDER = [
  "power",
  "cylinder",
  "axis",
  "addition",
  "baseCurve",
  "diameter"
];
const getFormattedValue = (attribute, value) => {
  if (typeof value === "string") {
    return value;
  }
  switch (attribute) {
    /**
     * For power and cylinder:
     * Append a `+` to positive values
     * and format values like `0` and `1.5` to `0.00` and `1.50`
     */
    case "power":
    case "cylinder":
      const valueWithDecimal = value.toFixed(2);
      if (value > 0) {
        return `+${valueWithDecimal}`;
      }
      return valueWithDecimal;
    default:
      return value.toString();
  }
};
const getDropdownOptionsFromRange = (attribute, range) => {
  let dropdownRanges = {};
  for (const value of range) {
    const formattedValue = getFormattedValue(attribute, value);
    dropdownRanges = {
      ...dropdownRanges,
      [formattedValue]: formattedValue
    };
  }
  return dropdownRanges;
};
const mapToPrescriptionRanges = (rawOpticalRanges) => {
  const mappedConfigs = [];
  if (!rawOpticalRanges) {
    return mappedConfigs;
  }
  PRESCRIPTION_SORT_ORDER.forEach((key) => {
    const rawRange = rawOpticalRanges[key];
    if (rawRange?.length && rawRange.length > 0) {
      mappedConfigs.push({
        name: key,
        attributeOptions: getDropdownOptionsFromRange(key, rawRange)
      });
    }
  });
  return mappedConfigs;
};
export {
  PRESCRIPTION_SORT_ORDER,
  mapToPrescriptionRanges
};
//# sourceMappingURL=map-to-prescription-ranges.js.map
